<template>
  <div class="answer" flex="main:center">
    <div class="answer-page" flex="cross:top">
      <!-- <div class="answer-page--sidebar">
        <div class="dot-title no-border">答题卡</div>
        <div class="sidebar-content" style="flex: 1; min-height: 0" flex="dir:top">
          <div class="moduleContent" style="flex: 1; min-height: 0">
            <div class="module">
              <div class="module-question">
                <div class="question-seq" v-for="(question, questionIndex) in paperList" :key="questionIndex">
                  <div class="question-seq--item" :class="{ isAnswer: question.isAnswer }"
                    @click="toQuestion(moduleIndex, questionIndex, question)">
                    {{ questionIndex + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="padding: 20px 0; border-top: 1px solid #f2f2f2">
            <div flex class="tips">
              <div class="tips-item">
                <div class="status true"></div>
                <div class="text">已做</div>
              </div>
              <div class="tips-item">
                <div class="status false"></div>
                <div class="text">未做</div>
              </div>
            </div>

            <div class="button_row">
              <el-button type="primary" @click="exeSubmit()">结束练习</el-button>
            </div>
          </div>
        </div>
      </div> -->

      <div class="answer-page--newsidebar">
        <div class="dot-title-new no-border">答题卡</div>
        <div class="white-back">
          <div style="padding-bottom: 16px ; border-bottom: 1px solid #f2f2f2; margin-bottom: 12px;">
            <div flex class="tips">
              <div class="tips-item" flex="cross:center">
                <div class="status true"></div>
                <div class="text">已做</div>
              </div>

              <div class="tips-item" flex="cross:center">
                <div class="status false"></div>
                <div class="text">未做</div>
              </div>
            </div>


          </div>
          <div class="sidebar-content" style="flex: 1; min-height: 0" flex="dir:top">
            <div class="moduleContent" style="flex: 1; min-height: 0">
              <div class="module-question">
                <div class="question-seq" v-for="(question, questionIndex) in paperList" :key="questionIndex">
                  <div class="question-seq--item" :class="{ isAnswer: question.isAnswer }"
                    @click="toQuestion(moduleIndex, questionIndex, question)">
                    {{ questionIndex + 1 }}
                  </div>
                </div>
              </div>
            </div>
            <el-button class="submitBtn" @click="exeSubmit()">结束练习</el-button>
          </div>
        </div>
      </div>

      <div class="answer-page--main" flex="dir:top">
        <div class="testPaper-title">{{ testPaperDetail.paperName }}</div>

        <div class="test-paper">
          <el-scrollbar style="height: 100%" wrap-class="test-paper-wrap" view-class="test-paper-view">
            <div style="padding: 0 40px">
              <div v-if="previewMode == 'paginated'">
                <el-carousel height="800px" width="800px" :autoplay="false" indicator-position="none"
                  :initial-index="oIndex" arrow="never" ref="cardShowx">
                  <el-carousel-item v-for="(question, questionIndex) in paperList" :key="questionIndex"
                    class="carousel_item">
                    <div class="answer_overflow">
                      <bc-answer-question :dict="{ label: dict.label }"
                        :class="`answer-module-${moduleIndex}--question-${current}`" :question="question"
                        :seq="questionIndex + 1" :key="questionIndex" :err="true"
                        @change="changeAnswerv2(questionIndex, $event)" @changeCancel="
                          changeCancel(question, questionIndex, $event)
                          "></bc-answer-question>
                    </div>
                    <div class="answerBut">
                      <el-button type="primary" style="width: 200px" @click="prevs()" class="preventBtn"
                        v-if="questionIndex != 0">上一题</el-button>
                      <el-button v-if="!question.isAnswer" type="primary" style="width: 200px"
                        @click="cancels(question, questionIndex)">选好了</el-button>
                      <el-button type="primary" style="width: 200px" @click="nexts()"
                        v-if="questionIndex != paperList.length - 1">下一题</el-button>
                    </div>
                    <div></div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addAnswerapi } from "@/api/answer/answer";
import XEUtils from "xe-utils";
import { paperGetToken } from "@/api/index/index";
import {
  gotQuestionExercise,
  delWrongQuestion,
} from "@/api/willingLearn/index.js";
import { MessageBox } from "element-ui";
export default {
  dicts: ["difficulty", "question_type"],
  data() {
    return {
      moduleIndex: 0,
      answerPlatform: "out",
      disabled: false,
      testPaperDetail: {},
      current: 0,
      previewMode: "paginated", //paginated scrolled
      oIndex: 0,
      synquestionIndex: 0,
      paperList: [],
      questionGrouplist: "",
      questionType: "",
      isDesc: "",
      questionId: "",
      errorBookIndex: 0,
      pageNum: "",
      pageSize: "",
    };
  },
  created() {
    this.goodId = this.$route.query.goodId;
    //第几个
    this.errorBookIndex = this.$route.query.errorBookIndex;
    this.pageNum = this.$route.query.pageNum;
    this.pageSize = this.$route.query.pageSize;
    this.questionType = this.$route.query.questionType;
    this.isDesc = this.$route.query.isDesc;
    this.getAnswerQuestions();
  },
  methods: {
    // 结束练习
    exeSubmit() {
      this.$confirm("是否要结束练习?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.close();
      });
    },
    //详情
    getAnswerQuestions() {
      paperGetToken().then((res) => {
        let data = {
          isDesc: this.isDesc,
          goodId: this.goodId,
          pageNum: 1,
          pageSize: this.pageSize,
          token: res.data,
          questionType: this.questionType == 0 ? "" : this.questionType,
        };
        gotQuestionExercise(data).then((res) => {
          console.log("this.paperList", res.rows);
          this.paperList = res.rows || [];
          //回答是否正确
          this.paperList.map((item) => {
            this.$set(item, "isAnswer", false);
          });
          //跳转第几个
          this.$nextTick(function () {
            this.toQuestion(0, this.errorBookIndex);
          });
        });
      });
    },
    //跳转
    toQuestion(e, index) {
      this.moduleIndex = e;
      this.questionIndex = index;
      this.$refs.cardShowx.setActiveItem(index);
    },
    // 下一题
    nexts(item) {
      this.$refs.cardShowx.next();
    },
    // 上一题
    prevs() {
      this.$refs.cardShowx.prev();
    },
    //题组回显
    changeCancel(question, questionIndex, val) {
      let answerResults = val.value;
      if (val.questionIndex || val.questionIndex === 0) {
        // console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
        answerResults = val.value.value;
        let questionGroup = this.paperList[questionIndex]["questionList"];
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswer",
          !!answerResults
        );
        let questionGroupAll = questionGroup.every((i) => i.isAnswer);
        this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
      }
      paperGetToken().then((token) => {
        //保存进度
        let params = {
          questionId:
            this.paperList[questionIndex].questionList[val.questionIndex].id,
          answerPlatform: this.answerPlatform,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.userName,
          paperId: this.testPaperId,
          answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          answerResults:
            this.paperList[questionIndex].questionList[val.questionIndex]
              .isAnswerResults.value,
          aprId: this.aprId,
          params1: this.goodsId,
          token: token.data,
        };
        addAnswerapi(params).then((res) => {
          this.$set(
            this.paperList[questionIndex]["questionList"][val.questionIndex],
            "standardAnswer",
            res.data.standardAnswer
          );
          this.$set(
            this.paperList[questionIndex]["questionList"][val.questionIndex],
            "selectAnswer",
            true
          );
          this.$set(
            this.paperList[questionIndex]["questionList"][val.questionIndex],
            "astatistics",
            res.data.astatistics
          );
          //判断题组的对错
          this.$set(
            this.paperList[questionIndex]["questionList"][val.questionIndex],
            "answerSituation",
            res.data.answerQuestionRecord.answerSituation
          );
          let delWrong = this.paperList[questionIndex]["questionList"].every(
            (i) => i.selectAnswer
          );
          let delanswer = this.paperList[questionIndex]["questionList"].every(
            (i) => i.answerSituation == "1"
          );
          if (delanswer == false) return;
          if (delWrong && delanswer) {
            //答对删除
            if (localStorage.getItem("automatically-removeV2") == "true") {
              delWrongQuestion({
                questionIds: question.questionId,
              });
            }
          }
        });
      });
    },
    //选好了回显
    cancels(item, index) {
      let val = this.questionGrouplist;
      let questionIndex = index;
      let answerResults = item.isAnswerResults;
      if (!answerResults) return;
      if (val.questionIndex || val.questionIndex === 0) {
        // console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
        answerResults = val.value.value;
        let questionGroup = this.paperList[questionIndex]["questionList"];
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswer",
          !!answerResults
        );
        let questionGroupAll = questionGroup.every((i) => i.isAnswer);
        this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
      } else {
        this.$set(this.paperList[questionIndex], "isAnswer", !!answerResults);
      }
      paperGetToken().then((token) => {
        //保存进度
        let params = {
          questionId: item.questionId,
          answerPlatform: this.answerPlatform,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.name,
          paperId: "",
          answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          answerResults: this.paperList[index].isAnswerResults,
          aprId: "",
          params1: this.goodsId,
          token: token.data,
        };
        addAnswerapi(params).then((res) => {
          if (res.data.answerQuestionRecord.answerSituation == 1) {
            //答对删除
            console.log(res.data.answerQuestionRecord.answerSituation);
            console.log(
              'localStorage.getItem("automatically-removeV2")',
              localStorage.getItem("automatically-removeV2")
            );

            if (localStorage.getItem("automatically-removeV2") == "true") {
              delWrongQuestion({
                questionIds: item.questionId,
              });
            }
          }
          this.$set(
            this.paperList[questionIndex],
            "standardAnswer",
            res.data.standardAnswer
          );
          this.$set(
            this.paperList[questionIndex],
            "astatistics",
            res.data.astatistics
          );
          this.$set(this.paperList[questionIndex], "selectAnswer", true);
        });
      });
    },

    //选择的回调
    async changeAnswerv2(questionIndex, val) {
      //回显模块的
      this.synquestionIndex = questionIndex;
      this.questionGrouplist = val;
      //选择的答案
      let answerResults = val.value;
      if (val.questionIndex || val.questionIndex === 0) {
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswerResults",
          answerResults
        );
      } else {
        this.$set(
          this.paperList[questionIndex],
          "isAnswerResults",
          answerResults
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.answer {
  width: 1400px;
  height: 100%;
  // background: #f2f2f2;
  margin: 0 auto;

  .testPaper-title {
    text-align: center;
    padding: 21px 0;
    font-size: 16px;
    color: #333;
    position: relative;
    line-height: 20px;
    // border-bottom: 1px solid #f2f2f2;
  }

  .answer-page {
    display: flex;
    padding-bottom: 20px;
    background: #f2f2f2;

    .answer-page--sidebar {
      width: 304px;
      background: #fffefd;
      border-radius: 6px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .count-down {
        padding: 10px 20px 0;
      }

      .sidebar-content {
        .moduleContent {
          padding-bottom: 20px;
          flex: 1;
          height: calc(100vh - 340px);
          overflow-y: scroll;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .module {
            padding: 20px 20px 10px;

            &+.module {
              border-top: 1px solid #f2f2f2;
            }

            .module-name {
              font-size: 14px;
              color: #333333;
              margin-bottom: 15px;
            }

            .module-question {
              margin-left: -5px;
              margin-right: -5px;

              &::after,
              &::before {
                display: table;
                content: "";
              }

              &::after {
                clear: both;
              }

              .question-seq {
                padding-left: 6px;
                padding-right: 5px;
                float: left;
                margin-bottom: 10px;

                .question-seq--item {
                  width: 30px;
                  height: 21px;
                  // line-height: 19px;
                  // text-align: center;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  box-sizing: border-box;
                  background: #ffffff;
                  border: 1px solid #2e9adb;
                  //border-radius: 6px;
                  font-size: 14px;
                  color: #333333;
                  user-select: none;
                  cursor: pointer;
                  transition: all ease 0.3s;

                  &.isAnswer {
                    background: #2e9adb;
                    color: #fff;
                  }
                }
              }
            }
          }
        }
      }
    }

    .answer-page--newsidebar {
      width: 304px;
      // background: #BEDBFE;
      background: #FFFFFF;
      border-radius: 12px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

      // border: 1px solid;
      // border-image: linear-gradient(180deg, rgba(40, 124, 247, 1) 20%, rgba(255, 255, 255, 1)) 1 1;

      .dot-title-new {
        padding: 13px 16px;
        background: #BEDBFE;
        border-radius: 12px 12px 0 0;
      }

      .white-back {
        width: 100%;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        position: relative;
        padding: 16px;

        // border: 1px solid #BEDBFE;
        .border {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          width: 100%;
          height: 64px;
          border: 1px solid;
          border-top: none;
          border-image: linear-gradient(180deg, #5F9BF4, rgba(255, 255, 255, 1)) 1 1;
        }
      }

      .count-down {
        background: linear-gradient(180deg, #F2F7FF 0%, #F8FAFC 100%);
        border-radius: 0px 0px 0px 0px;
        padding-top: 32px;
        padding-bottom: 26px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

        .time-text {
          font-family: DingTalk JinBuTi, DingTalk JinBuTi;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #27272A;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;
          z-index: 12;
        }
      }

      .sidebar-content {
        .moduleContent {
          // padding-bottom: 20px;
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          overflow-x: hidden;
          max-height: 390px;
          border-bottom: 1px solid #F4F4F5;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .module-question {
            margin-left: -5px;
            margin-right: -5px;

            &::after,
            &::before {
              display: table;
              content: "";
            }

            &::after {
              clear: both;
            }

            .question-seq {
              padding-left: 6px;
              padding-right: 5px;
              float: left;
              margin-bottom: 10px;

              .question-seq--item {
                width: 32px;
                height: 32px;
                line-height: 19px;
                text-align: center;
                background: #F4F4F5;
                border-radius: 4px 4px 4px 4px;
                user-select: none;
                cursor: pointer;
                transition: all ease 0.3s;
                font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                font-weight: 400;
                font-size: 14px;
                color: #52525B;
                text-align: left;
                font-style: normal;
                text-transform: none;
                display: flex;
                align-items: center;
                justify-content: center;

                &.isAnswer {
                  background: #287CF7;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }

    .answer-page--main {
      width: 1080px;
      height: calc(100vh - 150px);
      background: #fffefd;
      border-radius: 6px;
      overflow: hidden;
      flex-direction: column;

      .test-paper {
        flex: 1;
        min-height: 0;

        ::v-deep .test-paper-wrap {
          overflow-x: hidden;
        }

        ::v-deep .test-paper-view {
          padding: 0 10px;
        }

        .paper-module {
          &+.paper-module {
            margin-top: 20px;
          }

          .paper-module--name {
            // margin-bottom: 24px;
          }
        }
      }
    }
  }
}

.submitBtn {
  width: 100%;
  background: #2e9adb;
  text-align: center;
  color: #fff;
  display: block;
  margin-top: 12px;
  background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}

.tips {
  // padding: 0px 20px 0px;
  // margin-bottom: 10px;
  display: flex;

  .tips-item {
    display: flex;

    &:last-child {
      margin-left: 20px;
    }

    .status {
      width: 10px;
      height: 10px;
      border: 1px solid #999999;

      &.true {
        background: #2e9adb;
        border-color: #2e9adb;
      }

      &.false {
        background: #fff;
      }
    }

    .text {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      margin-left: 6px;
    }
  }
}

::v-deep .question {
  height: auto;

  .questionGroupContent {
    display: block;

    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: inline;

      .stem-content {
        display: inline;

        .text-break-all {
          display: inline;

          p {
            //display: inline;
          }
        }
      }
    }
  }

  .group-content {
    display: inline;

    .question {
      padding-left: 20px;
    }
  }

  .stem {
    .stem-box {
      display: block;

      .questionType {
        display: inline-block;
      }

      .questionSeq,
      .questionScore {
        display: inline-block;
      }

      .content {
        display: inline;

        .stem-content {
          display: inline;

          .text-break-all {
            display: inline;

            p {
              //display: inline;
            }
          }
        }
      }
    }
  }

  .option-item {
    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: block;

      .stem-content {
        display: block;

        .text-break-all {
          display: block;

          p {
            display: block;
          }
        }
      }
    }
  }
}

.dot-title {
  text-align: center;
  margin: 10px 0;
}

::v-deep .answerBut {
  width: 500px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 20px;

  .el-button {
    border-radius: 12px;
    background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
  }

  .preventBtn {
    background: #fff;
    color: #287CF7;
  }
}

.button_row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}

.answer_overflow {
  height: calc(100vh - 300px);
  overflow-y: scroll;
}

.carousel_item {
  width: 900px;
}

.carousel_box {
  width: 1000px;
}
</style>
